// Social Media Brand Icons

export const GoogleIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="size-5"
    {...props}
  >
    <path
      d="M23.52 12.29C23.52 11.43 23.44 10.61 23.3 9.82H12V14.45H18.46C18.18 15.93 17.33 17.18 16.07 18.01V20.97H19.94C22.2 18.89 23.52 15.82 23.52 12.29Z"
      fill="#4285F4"
    />
    <path
      d="M12 24C15.24 24 17.96 22.92 19.94 21.09L16.07 18.13C15 18.85 13.62 19.27 12 19.27C8.88 19.27 6.23 17.17 5.29 14.35H1.28V17.46C3.25 21.37 7.31 24 12 24Z"
      fill="#34A853"
    />
    <path
      d="M5.29 14.35C5.05 13.63 4.92 12.87 4.92 12.09C4.92 11.31 5.05 10.55 5.29 9.83V6.72H1.28C0.46 8.35 0 10.17 0 12.09C0 14.01 0.46 15.83 1.28 17.46L5.29 14.35Z"
      fill="#FBBC05"
    />
    <path
      d="M12 4.91C13.76 4.91 15.34 5.52 16.58 6.7L20.03 3.25C17.96 1.32 15.24 0 12 0C7.31 0 3.25 2.63 1.28 6.54L5.29 9.65C6.23 6.83 8.88 4.91 12 4.91Z"
      fill="#EA4335"
    />
  </svg>
);

export const FacebookIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 17.9895 4.38823 22.954 10.125 23.8542V15.4688H7.07813V12H10.125V9.35625C10.125 6.34875 11.9165 4.6875 14.6576 4.6875C15.9705 4.6875 17.3438 4.92188 17.3438 4.92188V7.875H15.8306C14.34 7.875 13.875 8.8 13.875 9.75V12H17.2031L16.6711 15.4688H13.875V23.8542C19.6118 22.954 24 17.9895 24 12Z"
      fill="currentColor"
    />
  </svg>
);

export const TikTokIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="size-5"
    {...props}
  >
    <path
      d="M17.1765 8.66347C18.7198 9.77064 20.6105 10.4221 22.6525 10.4221V6.47861C22.2661 6.47869 21.8806 6.43825 21.5025 6.35786V9.46193C19.4606 9.46193 17.5702 8.81049 16.0265 7.7034V15.7509C16.0265 19.7766 12.7745 23.0399 8.76333 23.0399C7.26666 23.0399 5.87556 22.5858 4.71997 21.807C6.03888 23.1604 7.87821 24 9.91309 24C13.9245 24 17.1766 20.7367 17.1766 16.7108V8.66347H17.1765V8.66347ZM18.5951 4.68499C17.8064 3.82023 17.2885 2.70267 17.1765 1.46717V0.959961H16.0867C16.361 2.53028 17.2966 3.87187 18.5951 4.68499ZM7.25706 18.7178C6.81638 18.1379 6.57824 17.4286 6.57931 16.6992C6.57931 14.858 8.06672 13.3651 9.90177 13.3651C10.2438 13.365 10.5837 13.4176 10.9096 13.5214V9.48977C10.5287 9.43739 10.1443 9.41515 9.7601 9.4233V12.5613C9.43394 12.4575 9.09384 12.4048 8.75177 12.4051C6.91671 12.4051 5.42938 13.8979 5.42938 15.7393C5.42938 17.0414 6.17284 18.1687 7.25706 18.7178Z"
      fill="#FF004F"
    />
    <path
      d="M16.0265 7.70332C17.5702 8.81041 19.4607 9.46185 21.5025 9.46185V6.35778C20.3628 6.11414 19.3538 5.5164 18.5951 4.68499C17.2966 3.87179 16.361 2.5302 16.0867 0.959961H13.2241V16.7106C13.2176 18.5468 11.7327 20.0336 9.90162 20.0336C8.82257 20.0336 7.86394 19.5174 7.25682 18.7178C6.17269 18.1687 5.42923 17.0413 5.42923 15.7394C5.42923 13.8981 6.91655 12.4052 8.75161 12.4052C9.1032 12.4052 9.44208 12.4602 9.75995 12.5614V9.42338C5.81921 9.50509 2.6499 12.7365 2.6499 16.7107C2.6499 18.6946 3.43913 20.4931 4.72006 21.8071C5.87565 22.5858 7.26675 23.04 8.76342 23.04C12.7747 23.04 16.0265 19.7765 16.0265 15.7509V7.70332H16.0265Z"
      fill="black"
    />
    <path
      d="M21.5025 6.3578V5.51848C20.4748 5.52005 19.4672 5.23119 18.5952 4.68493C19.3671 5.53306 20.3835 6.11787 21.5025 6.3578ZM16.0867 0.959983C16.0605 0.809911 16.0404 0.658851 16.0265 0.507214V0H12.074V15.7508C12.0677 17.5868 10.5829 19.0736 8.75164 19.0736C8.214 19.0736 7.70638 18.9455 7.25685 18.7179C7.86397 19.5174 8.82259 20.0336 9.90164 20.0336C11.7326 20.0336 13.2177 18.5469 13.2241 16.7107V0.959983H16.0867ZM9.76014 9.42341V8.52989C9.42988 8.48459 9.09691 8.46186 8.76353 8.46202C4.75192 8.46194 1.5 11.7254 1.5 15.7508C1.5 18.2745 2.77806 20.4987 4.72017 21.807C3.43924 20.493 2.65001 18.6944 2.65001 16.7106C2.65001 12.7365 5.81924 9.50511 9.76014 9.42341Z"
      fill="#00F2EA"
    />
  </svg>
);
export const WhiteTikTokIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_747_15638)">
      <path
        d="M14.2271 0H10.8565V13.6232C10.8565 15.2464 9.56016 16.5797 7.94688 16.5797C6.33361 16.5797 5.03724 15.2464 5.03724 13.6232C5.03724 12.029 6.30481 10.7246 7.86047 10.6667V7.24639C4.43226 7.30433 1.66666 10.1159 1.66666 13.6232C1.66666 17.1594 4.48988 20 7.9757 20C11.4615 20 14.2847 17.1304 14.2847 13.6232V6.63767C15.5523 7.56522 17.1079 8.11594 18.75 8.14494V4.72464C16.2149 4.63768 14.2271 2.55072 14.2271 0Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_747_15638">
        <rect width={20} height={20} fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const XIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="size-5"
    {...props}
  >
    <path
      d="M18.901 0H22.581L14.542 9.189L24 21.691H16.596L10.796 14.108L4.156 21.691H0.474L9.049 11.89L0 0H7.594L12.862 6.965L18.901 0ZM17.61 19.489H19.649L6.486 2.086H4.298L17.61 19.489Z"
      fill="currentColor"
    />
  </svg>
);

export const LinkedInIcon = ({ className }: { className?: string }) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M20.447 20.452H16.892V14.881C16.892 13.553 16.866 11.844 15.04 11.844C13.188 11.844 12.905 13.287 12.905 14.786V20.452H9.35V9H12.761V10.564H12.809C13.284 9.664 14.444 8.715 16.173 8.715C19.773 8.715 20.447 11.085 20.447 14.168V20.452Z"
      fill="currentColor"
    />
    <path
      d="M5.337 7.433C4.197 7.433 3.274 6.509 3.274 5.369C3.274 4.229 4.197 3.305 5.337 3.305C6.477 3.305 7.4 4.229 7.4 5.369C7.4 6.509 6.477 7.433 5.337 7.433Z"
      fill="currentColor"
    />
    <path d="M7.119 20.452H3.556V9H7.119V20.452Z" fill="currentColor" />
  </svg>
);

export const InstagramIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="size-5"
    {...props}
  >
    <path
      d="M12 2.163C15.204 2.163 15.584 2.175 16.85 2.233C20.102 2.381 21.621 3.924 21.769 7.152C21.827 8.417 21.838 8.797 21.838 12.001C21.838 15.206 21.826 15.585 21.769 16.85C21.62 20.075 20.105 21.621 16.85 21.769C15.584 21.827 15.206 21.839 12 21.839C8.796 21.839 8.416 21.827 7.151 21.769C3.891 21.62 2.38 20.07 2.232 16.849C2.174 15.584 2.162 15.205 2.162 12C2.162 8.796 2.175 8.417 2.232 7.151C2.381 3.924 3.896 2.38 7.151 2.232C8.417 2.175 8.796 2.163 12 2.163ZM12 0C8.741 0 8.333 0.014 7.053 0.072C2.695 0.272 0.273 2.69 0.073 7.052C0.014 8.333 0 8.741 0 12C0 15.259 0.014 15.668 0.072 16.948C0.272 21.306 2.69 23.728 7.052 23.928C8.333 23.986 8.741 24 12 24C15.259 24 15.668 23.986 16.948 23.928C21.302 23.728 23.73 21.31 23.927 16.948C23.986 15.668 24 15.259 24 12C24 8.741 23.986 8.333 23.928 7.053C23.732 2.699 21.311 0.273 16.949 0.073C15.668 0.014 15.259 0 12 0ZM12 5.838C8.597 5.838 5.838 8.597 5.838 12C5.838 15.403 8.597 18.163 12 18.163C15.403 18.163 18.162 15.404 18.162 12C18.162 8.597 15.403 5.838 12 5.838ZM12 16C9.791 16 8 14.21 8 12C8 9.791 9.791 8 12 8C14.209 8 16 9.791 16 12C16 14.21 14.209 16 12 16ZM18.406 4.155C17.61 4.155 16.965 4.8 16.965 5.595C16.965 6.39 17.61 7.035 18.406 7.035C19.201 7.035 19.845 6.39 19.845 5.595C19.845 4.8 19.201 4.155 18.406 4.155Z"
      fill="currentColor"
    />
  </svg>
);

export const SubstackIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="size-5"
    {...props}
  >
    <path
      d="M22.539 8.242H1.46V5.406H22.539V8.242ZM1.46 10.812V24L12 18.11L22.54 24V10.812H1.46ZM22.54 0H1.46V2.836H22.54V0Z"
      fill="currentColor"
    />
  </svg>
);

export const MediumIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="size-5"
    {...props}
  >
    <path
      d="M13.54 12C13.54 15.94 10.353 19.13 6.42 19.13C2.486 19.13 -0.7 15.94 -0.7 12C-0.7 8.06 2.486 4.87 6.42 4.87C10.353 4.87 13.54 8.06 13.54 12ZM20.96 12C20.96 15.71 19.367 18.72 17.4 18.72C15.433 18.72 13.84 15.71 13.84 12C13.84 8.29 15.433 5.28 17.4 5.28C19.367 5.28 20.96 8.29 20.96 12ZM24 12C24 15.35 23.457 18.07 22.79 18.07C22.123 18.07 21.58 15.35 21.58 12C21.58 8.65 22.123 5.93 22.79 5.93C23.457 5.93 24 8.65 24 12Z"
      fill="currentColor"
    />
  </svg>
);

export const YouTubeIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#clip0_1537_12073)">
      <path fillRule="evenodd" clipRule="evenodd" d="M18.9554 4.02841C19.2657 4.34071 19.4886 4.72904 19.6017 5.15453C20.0198 6.72498 20.0198 9.99998 20.0198 9.99998C20.0198 9.99998 20.0198 13.275 19.6017 14.8454C19.4886 15.2709 19.2657 15.6593 18.9554 15.9716C18.6451 16.2839 18.2582 16.5092 17.8335 16.625C16.2698 17.0454 10.0198 17.0454 10.0198 17.0454C10.0198 17.0454 3.76984 17.0454 2.2062 16.625C1.78144 16.5092 1.39455 16.2839 1.08424 15.9716C0.773933 15.6593 0.551091 15.2709 0.438018 14.8454C0.0198365 13.275 0.0198364 9.99998 0.0198364 9.99998C0.0198364 9.99998 0.0198365 6.72498 0.438018 5.15453C0.551091 4.72904 0.773933 4.34071 1.08424 4.02841C1.39455 3.7161 1.78144 3.49078 2.2062 3.37498C3.76984 2.95453 10.0198 2.95453 10.0198 2.95453C10.0198 2.95453 16.2698 2.95453 17.8335 3.37498C18.2582 3.49078 18.6451 3.7161 18.9554 4.02841ZM13.2017 10L7.9744 7.02615V12.9739L13.2017 10Z" fill="white" />
    </g>
    <defs>
      <clipPath id="clip0_1537_12073">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const WebsiteIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12.5897 17.3032L11.4111 18.4817C9.78393 20.109 7.14575 20.109 5.51857 18.4817C3.89138 16.8545 3.89138 14.2164 5.51857 12.5892L6.69708 11.4107M17.3037 12.5892L18.4822 11.4107C20.1093 9.78349 20.1093 7.1453 18.4822 5.51812C16.855 3.89093 14.2168 3.89093 12.5897 5.51812L11.4111 6.69663M9.08371 14.9165L14.9171 9.08324"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
